module.exports = __webpack_public_path__ + "static/media/kitchenadvisor-white.c207842c.svg";